import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import Styles from './TabGroupBensServicos.css';
import MobileOnlyCarousel from '@/components/atoms/MobileOnlyCarousel';
import kebabCase from 'lodash/kebabCase';
import { BensServicosTabIds } from '@/data/misc/bens-servicos-tabs';

const Tabs = [
  {
    id: BensServicosTabIds.paravoce,
    label: 'Para você',
  },
  {
    id: BensServicosTabIds.parasuaempresa,
    label: 'Para sua empresa',
  },
];

/**
 * Renders the TabGroupBensServicos component.
 *
 * @param {Object} props - The component props.
 * @param {number} props.tab - The currently selected tab.
 * @param {function(number): void} props.onTabSelected - Callback fired when a tab is selected.
 * @returns {React.JSX.Element} The rendered component.
 */
function TabGroupBensServicos({ tab, onTabSelected }) {
  const embla = useRef();

  useEffect(() => {
    if (!embla.current) return;

    embla.current.scrollTo(tab);
  }, [tab]);

  return (
    <>
      <section className="tabs-container" id="bens-servicos-tabs">
        <MobileOnlyCarousel
          id="bens-servicos-tabs-scroll"
          customEmblaCarouselRef={embla}
          options={{
            align: 'center',
            slidesToScroll: 1,
            startIndex: tab,
            speed: 150,
          }}
          onSlideChanged={(index) => {
            onTabSelected(index);
          }}
          useThreshold
          threshold={576}
        >
          {({ className }) => (
            <>
              {Tabs.map((t) => (
                <div
                  key={`tab-id-bens-servicos-${t.id}`}
                  className={clsx(
                    'tab-item',
                    className,
                    t.id === tab && 'active',
                    // this is for tag manager/seo only
                    `bens-servicos-tab-${kebabCase(t.label)}`,
                  )}
                  onClick={(ev) => {
                    ev.preventDefault();
                    onTabSelected(t.id);
                  }}
                >
                  <p>{t.label}</p>
                  <span />
                </div>
              ))}
            </>
          )}
        </MobileOnlyCarousel>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupBensServicos;
